module.exports = __webpack_public_path__ + "static/media/logo.05446d93.svg";